export default {
	data() {
		return {
			filterProducts: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterProducts._id": {
			handler(val) {
				let fieldName = "product_colors";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	}
};
